import { Controller } from "@hotwired/stimulus";
import Userback from "@userback/widget";

export default class extends Controller {
  static values = {
    accessToken: String,
    userId: String,
    userEmail: String,
    env: String,
    localeStrings: String,
  };

  connect() {
    if (!this.hasAccessTokenValue) {
      return;
    }

    Userback(this.accessTokenValue, {
      user_data: {
        id: this.userIdValue,
      },
    })
      .then((widget) => {
        this.widget = widget;
      })
      .catch((error) => {
        console.warn("Userback widget failed to initialize:", error);
      });
  }

  disconnect() {
    if (this.widget && typeof this.widget.destroy === "function") {
      this.widget.destroy();
      this.widget = null;
    }
  }
}
